import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen" role="status" aria-live="polite" aria-busy="true">
      <div className="loading-screen__backdrop" />
      <div className="loading-screen__shell">
        <div className="loading-screen__spinner" aria-hidden="true">
          <span className="loading-screen__spinner-ring loading-screen__spinner-ring--outer" />
          <span className="loading-screen__spinner-ring loading-screen__spinner-ring--inner" />
          <span className="loading-screen__spinner-core" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
